var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinesList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.182,
    height: 33.999,
    viewBox: "0 0 28.182 33.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#0081c6;stroke-linecap:square;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.545,9h3.636V35.909H6V9H9.636",
    transform: "translate(-6 -3.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17,26.909l3.636,3.636L27.182,24",
    transform: "translate(-9 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.182,5.636a3.636,3.636,0,1,0-7.273,0H15V10H28.091V5.636Z",
    transform: "translate(-8.455 -2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinesList);
export default __webpack_public_path__ + "static/media/Icon_Lines_List.6a863dbfe082f3659552e1b5e906a64c.svg";
export { ForwardRef as ReactComponent };